export const ANNOUNCEMENTS = 'announcement';
export const DRAFT = 'draft';
export const SENT = 'sent';
